import React from "react";
import Login from "../../components/Login";
import Spring from "../../components/Spring";
import { Container } from "./styles";

const LoginScreen = () => {
    return (
        <Container>
            <div>
                <Login />
            </div>
        </Container>
    );
};

export default LoginScreen;